import Pages from './Pages'
import PageEdit from './PageEdit'

export const pageRoutes = [
    {
      path: '/',
      name: 'Pages',
      component: Pages,
      meta: { requiresAuth: true, minRole: 1}
    },
    {
      path: '/pages',
      name: 'Pages',
      component: Pages,
      meta: { requiresAuth: true, minRole: 1}
    },
    {
      path: '/page/:id',
      name: 'PageEdit',
      component: PageEdit,
      meta: { requiresAuth: true, minRole: 2}
    }]


// WEBPACK FOOTER //
// ./src/CORE/modules/PAGES/routes.js